import React, { useState, useEffect } from "react";
import "./Modal.css";
import Alert from "@mui/material/Alert";
import CheckIcon from "@mui/icons-material/Check";

interface ModalProps {
  isOpen: boolean;
  onClose: () => void;
}

const GitlabModal: React.FC<ModalProps> = ({ isOpen, onClose }) => {
  const [notification, setNotification] = useState<string | null>(null);
  const [formData, setFormData] = useState({
    username: "",
    password: "",
    email: "",
    token: "",
    repoName: "",
    sid: "",
    uid: "",
  });
  const [data, setData] = useState<any>(null); // Stato per la risposta della chiamata API

  const [severity, setSeverity] = useState<
    "success" | "info" | "warning" | "error" | undefined
  >("success");

  let showNameField: boolean = false;
  let showPasswordField: boolean = false;
  let showEmailField: boolean = false;
  let showTokenField: boolean = false;
  let repoName: boolean = false;

  useEffect(() => {
    const fetchData = async () => {
      try {
        const requestHeaders: HeadersInit = new Headers();
        if (process.env.REACT_APP_IS_NGROK_ACTIVE === "true") {
          requestHeaders.set("ngrok-skip-browser-warning", "69420");
        }
        const response = await fetch(
          `${process.env.REACT_APP_BACKEND_BASE_URL}/deploy/gitlab/dialog-info`,
          {
            method: "GET",
            headers: requestHeaders,
          }
        );

        if (response.ok) {
          const result = await response.json();
          setData(result);
        } else {
          setNotification("An error occurred. Please try again");
          setSeverity("error");
        }
      } catch (error) {
        setNotification("An error occurred. Please try again");
        setSeverity("error");
      }
    };

    if (isOpen) {
      fetchData();
    }
  }, [isOpen]);

  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    let uid: string =
      window.sessionStorage.getItem("uid") ?? "JEVZyG7f36S8BPNE6kSTryos43t1";
    let dfMessenger = document.getElementById("dfMessenger");
    const sid = dfMessenger?.getAttribute("session-id") ?? "";

    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value,
      sid: sid,
      uid: uid,
    });
  };

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();

    try {
      const response = await fetch(
        `${process.env.REACT_APP_BACKEND_BASE_URL}/deploy/gitlab/login-data`,
        {
          method: "POST",
          body: JSON.stringify(formData),
        }
      );

      if (response.ok) {
        setNotification("Credentials saved.");
        setSeverity("success");
        setTimeout(function () {
          onClose();
          setNotification(null);
          setData(null);
          setFormData({
            username: "",
            password: "",
            email: "",
            token: "",
            repoName: "",
            sid: "",
            uid: "",
          });
        }, 2000);
      } else {
        setNotification("An error occurred. Please try again");
        setSeverity("error");
      }
    } catch (error) {
      setNotification("An error occurred. Please try again");
      setSeverity("error");
    }
  };

  if (data) {
    let fields = data.fields;
    fields.forEach(function (field: String) {
      switch (field) {
        case "username": {
          showNameField = true;
          break;
        }
        case "password": {
          showPasswordField = true;
          break;
        }
        case "email": {
          showEmailField = true;
          break;
        }
        case "token": {
          showTokenField = true;
          break;
        }
        case "repository name": {
          repoName = true;
          break;
        }
        default: {
          console.log("Invalid choice");
          break;
        }
      }
    });
  }

  return (
    <>
      {isOpen && (
        <div className="modal">
          <div className="modal-content">
            <span className="close" onClick={onClose}>
              &times;
            </span>
            <div className="header-title">
              <img
                className="icon"
                src="https://gitlab.com/assets/logo-911de323fa0def29aaf817fca33916653fc92f3ff31647ac41d2c39bbe243edb.svg"
                alt="Placeholder"
              />
              <h1>Sign in</h1>
            </div>
            {notification && (
              <Alert severity={severity} variant="outlined">
                <div
                  style={
                    severity === "error" ? { color: "red" } : { color: "black" }
                  }
                >
                  {notification}
                </div>
              </Alert>
            )}
            <form className="modalForm" onSubmit={handleSubmit}>
              {showNameField && (
                <label>
                  Name:
                  <input
                    className="input-form"
                    type="text"
                    name="username"
                    value={formData.username}
                    onChange={handleInputChange}
                  />
                </label>
              )}
              {showPasswordField && (
                <label>
                  Password:
                  <input
                    className="input-form"
                    type="password"
                    name="password"
                    value={formData.password}
                    onChange={handleInputChange}
                  />
                </label>
              )}
              {showEmailField && (
                <label>
                  Email:
                  <input
                    className="input-form"
                    type="email"
                    name="email"
                    value={formData.email}
                    onChange={handleInputChange}
                  />
                </label>
              )}
              {showTokenField && (
                <label>
                  Token:
                  <input
                    className="input-form"
                    type="text"
                    name="token"
                    value={formData.token}
                    onChange={handleInputChange}
                  />
                </label>
              )}
              {repoName && (
                <label>
                  Repository Name:
                  <input
                    className="input-form"
                    type="text"
                    name="repoName"
                    value={formData.repoName}
                    onChange={handleInputChange}
                  />
                </label>
              )}
              <div style={{ display: "flex", marginInline: "auto" }}>
                <button
                  className="modal-button"
                  type="button"
                  onClick={handleSubmit}
                >
                  Save
                </button>
              </div>
            </form>
          </div>
        </div>
      )}
    </>
  );
};
export default GitlabModal;
